import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import DOMPurify from "dompurify";
const LENGTH_LIMIT = 100
export default function ActiveHTMLDescription({ value, displyreadorless = true }) {
  const [expanded, setExpanded] = useState(false);
  const [shouldShowToggle, setShouldShowToggle] = useState(false);
  const contentRef = useRef(null);
  const measureRef = useRef(null);

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  const decodedValue = DOMPurify.sanitize(decodeHtml(value || ""));

  useEffect(() => {
    if (decodedValue) {
      setShouldShowToggle(decodedValue.length > LENGTH_LIMIT);
    }
  }, [decodedValue]);

  return (
    <div className="description-sec-p">
      <style>
        {`
          .custom-html p, 
          .custom-html h1, 
          .custom-html h2, 
          .custom-html h3, 
          .custom-html h4, 
          .custom-html h5, 
          .custom-html h6 {
            color: #000000ff !important;
            margin: 0 0 8px 0;
          }

          .custom-html ul, 
          .custom-html ol {
            margin: 0 !important;
            padding-left: 20px !important;
            display: block !important;
          }

          .custom-html li {
            margin-bottom: 4px;
            display: list-item !important;
            list-style-position: outside !important;
          }

          .custom-html ul li {
            list-style-type: disc !important;
          }

          .custom-html ol li {
            list-style-type: decimal !important;
          }

          /* Truncate with max-height and ensure bullets are visible */
          .custom-html.truncate {
            max-height: 48px;
            overflow: hidden;
            position: relative;
          }

          .custom-html.truncate::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 20px;
            background: linear-gradient(transparent, white);
            pointer-events: none;
          }

          .view-toggle {
            color: #007bff;
            cursor: pointer;
            font-weight: 500;
            margin-top: 5px;
            display: inline-block;
          }

          /* Force show bullets in all states */
          .custom-html * {
            box-sizing: border-box;
          }

          /* Hidden element for measuring full height */
          .measure-element {
            position: absolute;
            visibility: hidden;
            pointer-events: none;
            height: auto;
            max-height: none;
          }

          
          .custom-html p{
          margin-left:0 !important;
          }
        `}
      </style>

      {value && (
        <>
          {/* Hidden element to measure actual content height */}
          <div
            ref={measureRef}
            className="custom-html measure-element"
            dangerouslySetInnerHTML={{ __html: decodedValue }}
          />

          {/* Visible content */}
          <div
            ref={contentRef}
            className={`custom-html ${!expanded ? "truncate" : ""}`}
            dangerouslySetInnerHTML={{ __html: decodedValue }}
          />

          {displyreadorless && shouldShowToggle && (
            <span
              className="view-toggle"
              onClick={() => setExpanded((prev) => !prev)}
            >
              {expanded ? "read less" : "read more"}
            </span>
          )}
        </>
      )}
    </div>
  );
}